// Modules
import AppInner from 'AppInner'
import { Provider } from 'react-redux'

// Components
import customTheme from 'theme/customTheme'

// Store
import store from 'store'

// UI
import { ChakraProvider } from '@chakra-ui/react'

const App = () => {
  return (
    <Provider store={store}>
      <ChakraProvider theme={customTheme}>
        <AppInner />
      </ChakraProvider>
    </Provider>
  )
}

export default App
